var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"box"}),(_vm.progress !== null && _vm.progress !== undefined && _vm.progress >= 0)?_c('span',[_vm._v(_vm._s(Math.round(_vm.progress * 100) + '%'))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }